import { atom } from "recoil";

export const StandardInfoAtom = atom({
    key: 'StandardInfo',
    default: [],
});

export const ListStandardInfoAtom = atom({
    key: 'ListStandardInfo',
    default: [],
});

export const CodeGroupStandardInfoAtom = atom({
    key: 'CodeGroupStandardInfo',
    default: '',
});

export const DetailStandardInfoAtom = atom({
    key: 'DetaStandardInfo',
    default: [],
});

export const DetailDeleteStandardInfoAtom = atom({
    key: 'DetailDeleteStandardInfo',
    default: [],
});

export const DetailSelectStandardInfoAtom = atom({
    key: 'DetailSelectStandardInfo',
    default: [],
});


export const InfraListAtom = atom({
    key: 'InfraList',
    default: [],
});